import { useDrupalUser } from '~/stores/drupalUser'

export default defineNuxtRouteMiddleware(() => {
  // During SSR (where we only have anonymous requests) we know for a fact
  // that the user has no access, so we can directly return here.
  if (import.meta.server) {
    return abortNavigation({
      statusCode: 404,
      statusMessage: 'Page Not Found',
    })
  }

  const drupalUser = useDrupalUser()

  if (!drupalUser.accessToolbar) {
    return abortNavigation({
      statusCode: 404,
      statusMessage: 'Page Not Found',
    })
  }
})
